import { use, useState } from "react"
import { useNavigate } from "react-router-dom"
import { signUp, login, logout } from "./utility";
import "./Auth.css";

const Auth = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [mode, setMode] = useState("login");
    const [username, setUsername] = useState("");
    const navigate = useNavigate();
    const [uid, setUid] = useState("");
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleSignUp = async () => {
        setError(null);
        setLoading(true);
        if (!email || !password || !username) {
            setError("All fields are required");
            setLoading(false);
            return;
        }
        const result = await signUp(email, password, username);
        setLoading(false);
        if (result.success) {
            localStorage.setItem('username', username);
            localStorage.setItem('uid', uid);
            navigate("/home");
        } else {
            setError(result.error);
        }
        clearFields();
    }

    const handleLogout = async () => {
        const success = await logout();
        if (success) {
            localStorage.removeItem('username');
            navigate("/");
        }
    }

    const handleLogin = async () => {
        setError(null);
        setLoading(true);
        if (!email || !password) {
            setError("Email and password are required");
            setLoading(false);
            return;
        }
        const result = await login(email, password);
        setLoading(false);
        if (result.success) {
            const userData = result.userData;
            if (userData && userData.username) {
                localStorage.setItem('username', userData.username);
                localStorage.setItem('uid', userData.uid);
            }
            navigate("/home");
        } else {
            setError(result.error);
        }
        clearFields();
    }

    const toggleMode = () => {
        setMode(mode === "login" ? "signup" : "login");
        setError(null);
        clearFields(); // Clear fields when switching modes
    }

    const handleLoginSubmit = (e) => {
        e.preventDefault(); // Prevents page refresh
        handleLogin();
    };

    const handleSignupSubmit = (e) => {
        e.preventDefault(); // Prevents page refresh
        handleSignUp();
    };

    const clearFields = () => {
        setEmail("");
        setPassword("");
        if (mode === "signup") {
            setUsername("");
        }
    };

    return (
        <div className="login-container">
            <h1>{mode === "login" ? "Login" : "Sign Up"}</h1>

            {error && <div className="error-message">{error}</div>}

            <form onSubmit={mode === "login" ? handleLoginSubmit : handleSignupSubmit}>
                <div className="inputs">
                    {mode === "signup" && (
                        <input
                            placeholder="Username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                        />
                    )}
                    <input
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        type="email"
                    />
                    <input
                        placeholder="Password"
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                </div>
                <div className="buttons">
                    <button type="submit" disabled={loading}>
                        {loading
                            ? (mode === "login" ? "Logging in..." : "Signing up...")
                            : (mode === "login" ? "Login" : "Sign Up")
                        }
                    </button>
                </div>
            </form>

            <div className="toggle-container">
                <p>
                    {mode === "login"
                        ? "Don't have an account?"
                        : "Already have an account?"}
                </p>
                <button
                    onClick={toggleMode}
                    className="toggle-button"
                >
                    {mode === "login" ? "Sign Up" : "Login"}
                </button>
            </div>
        </div>
    );
}

export default Auth;